import axiosInstance from './axiosInstance'

const axiosAdapter = () => {
    return { get, post, addResponseMiddleware }
};

async function post(relativeUrl, data, config) {
    const returnObject = { data: null, error: null }
    await axiosInstance
        .post(relativeUrl, data, config)
        .then(responseData => {
            returnObject.data = responseData.data
        })
        .catch(error => {
            returnObject.error = error
        })
    return returnObject
}

async function get(relativeUrl, params, config) {
    params = new URLSearchParams(params)
    config = Object.assign({params}, config)
    const returnObject = { data: null, error: null }
    await axiosInstance
        .get(relativeUrl, config )
        .then(responseData => {
            returnObject.data = responseData.data
        })
        .catch(error => {
            returnObject.error = error
        })
    return returnObject
}

function addResponseMiddleware(middleware) {
    axiosInstance.interceptors.response.use(middleware)
}

export default axiosAdapter
